export default {
  default: {
    addressModalHeaderTitle: 'Case Study',
    caseStudy: {
      imageDeleted: 'Image Deleted',
    },
  },
}
